export const loggingIn = {
  login: "auth/login",
};
